import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgProgressModule } from 'ngx-progressbar';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSidenavModule } from '@angular/material/sidenav';
import { PortalModule } from '@angular/cdk/portal';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { CustomersRoutingModule } from './customers-routing.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { CustomersComponent } from './customers.component';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { SharedModule } from '../shared/shared.module';
import { CustomerFormComponent } from './customer-form/customer-form.component';
import { ManageCustomerComponent } from './manage-customer/manage-customer.component';
import { CustomerService } from '../services/customer.service';
import { EnrollProgramComponent } from './enroll-program/enroll-program.component';

@NgModule({
  imports: [
    CommonModule,
    CustomersRoutingModule,
    NgProgressModule,
    NgbModule,
    NgxPaginationModule,
    FormsModule,
    SharedModule,
    MatSortModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatGridListModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    ColorPickerModule,
    NgxDropzoneModule,
    BreadcrumbModule,
    MatButtonModule,
    MatSidenavModule,
    PortalModule,
    MatBadgeModule,
    MatDividerModule,
    MatListModule,
    MatNativeDateModule,
    MatDatepickerModule,
    ChildHeaderModule
  ],
  declarations: [
    CustomersComponent,
    CustomerFormComponent,
    EnrollProgramComponent,
    ManageCustomerComponent
  ],

  providers: [
    // SharedService,
    CustomerService,
    // AdobeService,
    // DialogService,
    // CanDeactivateGuard,
    // PendingChangesGuard,
    // CspTransitionSkuPipe
  ],

  entryComponents: [
    // MicrosoftCloudAgreementComponent,
    // ConfirmSplaOrderComponent,
    // AddAddonComponent,
    // ConfigureEndUserComponent
  ],
})
export class CustomersModule {
}
